import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar"; // Ensure correct path to Navbar component
import "../styles/common/roots.css";
import "../styles/HomePage.css";

const HomePage = () => {
  useEffect(() => {
    // Ensure the page starts from the top
    window.scrollTo(0, 0);

    // Get the background color from the CSS variable
    const backgroundColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--background-color");

    // Update the theme-color meta tag
    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag.setAttribute("content", backgroundColor);
    }
  }, []);

  return (
    <div className="homeBody">
      {/* Navbar component */}
      <Navbar />

      {/* Main container */}
      <div className="container-fluid mx-lg-fluid">
        {/* Row for intro content */}
        <div className="row">
          <div className="col-lg-6 introCol">
            <div className="intro-container order-1 order-lg-1">
              {/* Intro heading */}
              <div className="intro mt-fluid">
                Learn, Practice,
                <br />
                and Master Morse Code!
              </div>
              {/* Intro description */}
              <div className="intro-content mt-3 order-3 order-lg-2">
                Your ultimate platform to learn, practice, and master Morse
                code—designed for beginners, enthusiasts, and experts alike.
              </div>
            </div>
          </div>

          {/* Column for images */}
          <div className="col-lg-6">
            <div className="image-container order-2 order-lg-3">
              {/* Background images */}
              <img
                src="homepage-blob.png"
                alt="background-blob"
                className="blob"
              />
              <img
                src="homepage-boy.png"
                alt="background-boy"
                className="boy"
              />
            </div>
          </div>
        </div>

        {/* Row for call-to-action buttons */}
        <div className="pill-container mt-pill">
          {/* Get Started button */}
          <a href="/lessons" className="pill get-started">
            Get Started
          </a>
          {/* Watch Video button */}
          <a
            href="https://www.youtube.com/watch?v=D8tPkb98Fkk"
            className="pill watch-video"
          >
            <i className="fas fa-play-circle"></i> Watch Video
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
